import { OutcomeDetailedMetricsTab } from '../../types/table.type';

export function replaceMatchingTab(
  baseTabs: OutcomeDetailedMetricsTab[],
  updatedTab: OutcomeDetailedMetricsTab,
): OutcomeDetailedMetricsTab[] {
  return baseTabs.map(
    (baseTable) => (baseTable.tabName === updatedTab.tabName
      ? updatedTab
      : baseTable
    ),
  );
}

export function replaceMatchingRow(
  baseTabs: OutcomeDetailedMetricsTab[],
  tabContainingUpdatedRow: OutcomeDetailedMetricsTab | null,
): OutcomeDetailedMetricsTab[] {
  if (!tabContainingUpdatedRow) return baseTabs;

  const targetTab = baseTabs.find((existingTab) => existingTab.tabName === tabContainingUpdatedRow.tabName);
  if (!targetTab) return baseTabs;

  const updatedTab = {
    ...targetTab,
    rows: targetTab.rows.map(
      (targetTabRow) => tabContainingUpdatedRow.rows.find((row) => row.cells[0]?.value === targetTabRow.cells[0]?.value) ?? targetTabRow,
    ),
  };

  return replaceMatchingTab(baseTabs, updatedTab);
}
